<div [class.has-design-context]="!!data?.map_feature_link" class="wrapper overflow-hidden">
  <div class="heading text-type-5">
    {{ data?.lines[0]?.activity_code?.location }}
    - {{ data?.lines[0]?.activity_code?.segment }}
  </div>
  <div class="length text-type-10 mt-[10px]">{{ data?.lines?.length }} activity ids</div>
  @if (data?.map_feature_link?.sheet) {
    <!-- A linked sheet is a one-line chip on the tile; the record's side panel keeps the full card and Open sheet -->
    <app-design-context-chips [link]="data.map_feature_link" />
  } @else if (data?.map_feature_link) {
    <app-design-context class="card-design-context" [link]="data.map_feature_link" [editable]="false" [projectId]="projectId$ | async" />
  }
  @if (displayMatched) {
    <div
      class="matched text-type-15">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}
    </div>
  }
</div>
